import { request } from "@/shared/api/http-client";
import {
  notificationActionEnvelopeSchema,
  notificationClickEnvelopeSchema,
  notificationCountEnvelopeSchema,
  notificationEnvelopeSchema,
  notificationListEnvelopeSchema,
  notificationPageEnvelopeSchema,
  notificationPopupEnvelopeSchema,
} from "./notification-contract";

export interface ListNotificationsParams {
  page?: number;
  size?: number;
  unreadOnly?: boolean;
}

const notificationPath = "/member/notifications";

function queryString(params: ListNotificationsParams) {
  const search = new URLSearchParams();
  if (params.page !== undefined) search.set("page", String(params.page));
  if (params.size !== undefined) search.set("size", String(params.size));
  if (params.unreadOnly !== undefined) {
    search.set("unreadOnly", String(params.unreadOnly));
  }
  const value = search.toString();
  return value ? `?${value}` : "";
}

export function listNotifications(params: ListNotificationsParams = {}) {
  return request(`${notificationPath}${queryString(params)}`, {
    method: "GET",
    schema: notificationPageEnvelopeSchema,
  });
}

export function getNotification(id: number) {
  return request(`${notificationPath}/${id}`, {
    method: "GET",
    schema: notificationEnvelopeSchema,
  });
}

export function getRecentNotifications(limit = 5) {
  return request(`${notificationPath}/recent?limit=${limit}`, {
    method: "GET",
    schema: notificationListEnvelopeSchema,
  });
}

export function getNotificationUnreadCount() {
  return request(`${notificationPath}/unread-count`, {
    method: "GET",
    schema: notificationCountEnvelopeSchema,
  });
}

export function getPendingNotificationPopup() {
  return request(`${notificationPath}/popup`, {
    method: "GET",
    schema: notificationPopupEnvelopeSchema,
  });
}

export function markNotificationRead(id: number) {
  return request(`${notificationPath}/${id}/read`, {
    method: "POST",
    schema: notificationActionEnvelopeSchema,
  });
}

export function markAllNotificationsRead() {
  return request(`${notificationPath}/read-all`, {
    method: "POST",
    schema: notificationCountEnvelopeSchema,
  });
}

export function acknowledgeNotificationPopup(id: number) {
  return request(`${notificationPath}/${id}/popup-ack`, {
    method: "POST",
    schema: notificationActionEnvelopeSchema,
  });
}

export async function confirmNotificationPopup(id: number) {
  await markNotificationRead(id);
  return acknowledgeNotificationPopup(id);
}

export function trackNotificationClick(id: number) {
  return request(`${notificationPath}/${id}/click`, {
    method: "POST",
    schema: notificationClickEnvelopeSchema,
  });
}
